/**
 * useUploadPhoto — Layer-3 hook for profile photo upload.
 *
 * Flow:
 * 1. PATCH /auth/photo/ — upload file, backend resizes + stores in S3.
 * 2. Invalidate authKeys.me() — AuthProvider's query refetches /me/ with updated photoUrl.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authKeys } from "@/shared/lib/queryKeys";
import { uploadPhoto } from "../api/authApi";

export function useUploadPhoto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => uploadPhoto(file),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: authKeys.me() });
    },
  });
}
